export default "__VITE_ASSET__D6SfxBk7__"